"use strict";

var _classCallCheck = require("/tmp/build_afa5e9373483510c3650f3d80edeec0c/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/tmp/build_afa5e9373483510c3650f3d80edeec0c/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

exports.implementation =
/*#__PURE__*/
function () {
  function NavigatorLanguageImpl() {
    _classCallCheck(this, NavigatorLanguageImpl);
  }

  _createClass(NavigatorLanguageImpl, [{
    key: "language",
    get: function get() {
      return "en-US";
    } // See Navigator constructor for languages

  }]);

  return NavigatorLanguageImpl;
}();